import { render } from "./svg10mAR.vue?vue&type=template&id=fb88302a&scoped=true"
import script from "./svg10mAR.vue?vue&type=script&lang=js"
export * from "./svg10mAR.vue?vue&type=script&lang=js"

import "./svg10mAR.vue?vue&type=style&index=0&id=fb88302a&lang=less&scoped=true"

import exportComponent from "E:\\suooter\\36live\\live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb88302a"]])

export default __exports__